import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overflow-y-scroll flex-grow pa-2 pt-4" }
const _hoisted_2 = { class: "notes-module-body" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  class: "flex-col",
  style: {"flex-grow":"0","width":"138px","max-width":"138px","margin-right":"8px"}
}
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "flex items-start" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col text-caption",
  style: {"flex-grow":"0","max-width":"400px","margin-right":"8px"}
}
const _hoisted_8 = { class: "flex flex-column" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center mb-1"
}
const _hoisted_11 = {
  key: 1,
  class: "flex items-center mb-1"
}
const _hoisted_12 = { class: "gray--text ml-1" }
const _hoisted_13 = {
  key: 2,
  class: "flex items-center mb-1"
}
const _hoisted_14 = { class: "gray--text ml-1" }
const _hoisted_15 = {
  key: 3,
  class: "flex items-center"
}
const _hoisted_16 = { class: "gray--text ml-1" }
const _hoisted_17 = {
  key: 4,
  class: "flex flex-column",
  style: {"margin":"30px 0 10px"}
}
const _hoisted_18 = {
  key: 5,
  class: "flex flex-column"
}
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientListItem = _resolveComponent("PatientListItem")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_TextCard = _resolveComponent("TextCard")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_expansion_panels, {
        variant: "accordion",
        flat: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointmentHistory, (appointment, i) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
              key: `patient-list-item-${appointment.uuid}`,
              class: _normalizeClass(['panel-bg', {'panel-border': i !== _ctx.appointmentHistory.length - 1}])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_PatientListItem, {
                        "image-url": _ctx.patient?.avatar,
                        title: _ctx.patient?.name,
                        timestamp: _ctx.$dayjs(appointment.starts_at).utc().format('YYYY-MM-DD HH:mm:ss'),
                        "no-padding": "",
                        style: {"flex-grow":"0","width":"260px","max-width":"260px","margin-right":"8px"}
                      }, null, 8, ["image-url", "title", "timestamp"]),
                      _createElementVNode("div", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-caption font-semibold gray--text mb-1" }, " Time in appointment ", -1)),
                        _createElementVNode("span", {
                          class: "block text-body-1",
                          textContent: _toDisplayString(_ctx.formatTime(appointment))
                        }, null, 8, _hoisted_5)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (appointment.doctors.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", {
                              class: "flex flex-column",
                              style: {"margin":"0 0 10px"}
                            }, [
                              _createElementVNode("span", { class: "gray--text font-weight-bold" }, " Scheduled ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.doctors, (doctor, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `appointment-${i}-${doctor.doctor?.uuid}`
                                }, [
                                  (doctor.doctor)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createVNode(_component_TextCard, {
                                          class: "list-group-item mb-2 cursor-pointer",
                                          unripple: "",
                                          text: `${_ctx.$dayjs.utc(doctor.scheduled_at).tz().format('MMM D, YYYY hh:mm A')} | ${doctor.doctor.name}`,
                                          initials: _ctx.$filters.initials(doctor.doctor.name),
                                          initialsColor: doctor.doctor.color,
                                          "no-border": true
                                        }, null, 8, ["text", "initials", "initialsColor"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(['flex','flex-col','text-caption', {'shift-to-center': appointment.doctors.length < 1}]),
                        style: {"flex-grow":"0","margin-left":"5px","max-width":"400px","margin-right":"8px"}
                      }, [
                        (!!appointment.checkedin_at || !!appointment.arrived_at || !!appointment.ended_at)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("span", { class: "gray--text font-weight-bold" }, " Stats ", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (!!appointment.checkedin_at)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "gray--text text--lighten-3" }, " Arrived at ", -1)),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$dayjs.utc(appointment.checkedin_at).tz().format('hh:mma')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!!appointment.arrived_at)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "gray--text text--lighten-3" }, " Appointment started ", -1)),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$dayjs.utc(appointment.arrived_at).tz().format('hh:mma')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!!appointment.ended_at)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "gray--text text--lighten-3" }, " Appointment ended ", -1)),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$dayjs.utc(appointment.ended_at).tz().format('hh:mma')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (appointment.treatments.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("span", { class: "gray--text font-weight-bold" }, " Treatments ", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (appointment.treatments.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.treatments, (treatment, i) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `appointment-${i}-${treatment.treatment?.uuid || treatment.uuid}`
                                }, [
                                  (treatment.treatment)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createVNode(_component_TextCard, {
                                          class: "list-group-item mb-2 cursor-pointer",
                                          unripple: "",
                                          text: treatment.treatment.full_name,
                                          initials: _ctx.$filters.initials(treatment.doctor?.name),
                                          initialsColor: treatment.doctor?.color,
                                          duration: treatment.time_elapsed,
                                          "no-border": true
                                        }, null, 8, ["text", "initials", "initialsColor", "duration"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}